import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class UserService {
  constructor(private readonly rest: RestService) {}

  // Ref user
  getRefUser(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/user/ref`);
  }

  updateRefUser(payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/user/ref`, payload);
  }

  // Tenant users
  getUsers(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/user`);
  }

  getUserById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/user/${id}`);
  }

  createUser(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/user`, payload);
  }

  updateUser(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/user/${id}`, payload);
  }
}
